import React, { Component } from "react";
import { Tab, Tabs } from "react-bootstrap";

class FileTabs extends Component {
  render() {
    return (
      <div className="ladger-section file-sec">
        <ul>
          <li>
            <div className="lable">Files</div>
          </li>
        </ul>
        <Tabs defaultActiveKey="pms" id="file-tabs" className="mb-3">
          <Tab eventKey="pms" title="PMS">
            {/* Placeholder for PMS content */}
            <div>
              <h5>PMS System Names</h5>
              {/* Example of a PMS system with a badge */}
              <div>
                <span>PMS System 1</span>
                <span className="badge">3/5 Received</span>
              </div>
              {/* Expandable rows for uploaded files will go here */}
            </div>
          </Tab>
          <Tab eventKey="pos" title="POS">
            {/* Placeholder for POS content */}
            <div>
              <h5>POS System Names</h5>
              <p>
                This tab will be added once we start to support POS system files.
              </p>
            </div>
          </Tab>
          <Tab eventKey="documents" title="Documents">
            {/* Placeholder for Documents content */}
            <div>
              <h5>Upload Documents</h5>
              <p>
                This is where clients will upload any file that is not specific to
                the PMS system.
              </p>
            </div>
          </Tab>
        </Tabs>
      </div>      
    );
  }
}

export default FileTabs;
